import React from 'react';
import capitalize from 'lodash/capitalize';
import { useTranslation } from '@shared/core';
import { EventType } from '@graphql/generated';
import { SpacingStack, TextV2 } from '@withjoy/joykit';
import { useAuth } from '@shared/components/AuthProvider';
import { JoyLogo } from '@shared/createEvent/JoyLogo';

import { useSocialAccountTelemetry } from './SocialAccount.telemetry';
import { SocialAccountWrapper, StyledButtonV2 } from './SocialAccount.styles';
import { wrapWithSocialAccountHealthProvider } from './SocialAccount.health';

export interface SocialAccountProps {
  appName: string;
  eventType: EventType;
}

export const SocialAccount: React.FC<SocialAccountProps> = wrapWithSocialAccountHealthProvider(({ appName, eventType }) => {
  const { t } = useTranslation('createEvent');
  const telemetry = useSocialAccountTelemetry();

  const { createEventTitle, currentAuthDisclaimer, goodNews, createEventCta } = t('socialAccount');

  const { provideLogout, currentUser } = useAuth();
  const socialProvider = currentUser.profile?.activeAlias?.provider;

  const handleCtaClick = () => {
    telemetry.socialIntercept(eventType, socialProvider);
    provideLogout({}, `${window.location.origin}/${appName}`);
  };

  return (
    <SocialAccountWrapper paddingTop={[10, 0]} spacing={12} textAlign="center" display="block !important">
      <JoyLogo />
      <SpacingStack spacing={4} paddingX={2}>
        <TextV2 textAlign="center" typographyVariant="hed3" marginBottom={4}>
          {createEventTitle()}
        </TextV2>

        <TextV2 textAlign="center" marginBottom={4}>
          {currentAuthDisclaimer({ provider: capitalize(socialProvider) })}
        </TextV2>

        <TextV2 textAlign="center" marginBottom={4}>
          {goodNews()}
        </TextV2>
        <StyledButtonV2 onClick={handleCtaClick} textAlign="center" marginX="auto">
          {createEventCta()}
        </StyledButtonV2>
      </SpacingStack>
    </SocialAccountWrapper>
  );
});
